import { render, staticRenderFns } from "./AdminUpload.vue?vue&type=template&id=0cf3a282&scoped=true"
import script from "./AdminUpload.vue?vue&type=script&lang=js"
export * from "./AdminUpload.vue?vue&type=script&lang=js"
import style0 from "./AdminUpload.vue?vue&type=style&index=0&id=0cf3a282&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf3a282",
  null
  
)

export default component.exports